<div class="record-actions">
  <div class="record-actions-header">
    <ng-container> {{ order() + 1 }}.</ng-container>
    @if (isChina) {
      <ng-container class="buttons">
        <a class="action-element"
          ><mat-icon
          class="handle print-hidden"
          color="y-icon"
          svgIcon="alt-handle-icon"
          color=""
          cdkDragHandle
          ></mat-icon
        ></a>
        <mat-icon
          class="green-close print-hidden"
          color="y-icon"
          svgIcon="close-icon-grey"
          (click)="removeRecord.emit(order())"
        ></mat-icon>
        <a (click)="goToRecordDetails()" class="action-element">
          <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
        </a>
      </ng-container>
    }
  </div>
  <div
    class="image-border"
    miq-bg-image
    [secureImage]="
      record() | reportFieldFormatter: { templateId: currentView().templateId, field: imageField, joinString: true } | async
    "
  ></div>
</div>
@if (showGroup()) {
  <div class="body-group-dropdown">
    <div>
      <span class="group-name">{{ 'reports.groupName' | translate }}</span>
    </div>
    <mat-form-field appearance="outline">
      <mat-select
        matNativeControl
        [(ngModel)]="selectedValue"
        (selectionChange)="selectionChanged()"
        autocomplete="no-autofill"
        >
        <mat-option [value]="0">{{ 'reports.none' | translate }}</mat-option>
        @for (group of recordLevelGroups; track group; let i = $index) {
          <mat-option
            [value]="group.groupID"
            [disabled]="group.isDisabled"
            >
            {{ group.groupName }}
          </mat-option>
        }
        <mat-option [value]="-1">{{ 'reports.addNewGroup' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
}
<div class="compare-body">
  @if (confidentialityTmpl()) {
    <li>
      <ng-container
        *ngTemplateOutlet="confidentialityTmpl(); context: { reportItem: record(), displayLabel: true, isDataOnly: true }"
      ></ng-container>
    </li>
  }
  @for (field of allDataFields(); track field; let index = $index) {
    <div>
      <div
        class="label"
        [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
        (click)="emitEditableFields($event, field.id)"
        >
        {{
        record() | reportFieldFormatter: { templateId: currentView().templateId, field: field, joinString: true } | async
        }}
      </div>
    </div>
  }
</div>
